import angular from 'angular';
import {
    FontFamilyService,
    FontStyleService,
    FoundryService,
    IFoundryModel,
} from '../../tn.common';
import { abbreviateStyleName } from '../../tn.common/functions/abbreviateStyleName';
import { LicenseService } from '../../tn.licenses/license.service/license-service';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import { LocalProjects } from '../local-projects.service/localProjects';

ProjectsDetail.$inject = [
    'project',
    'tnLicenseService',
    'localProjects',
    'tnFontFilterService',
    '$tnPopover',
    '$scope',
    '$filter',
    '$q',
    '$state',
    'foundryService',
    'FontFamilyService',
    'FontStyleService',
];

export function ProjectsDetail(
    project,
    licenseService: LicenseService,
    localProjects: LocalProjects,
    filterService,
    $tnPopover: PopoverService,
    $scope,
    $filter,
    $q,
    $state,
    foundryService: FoundryService,
    familyService: FontFamilyService,
    styleService: FontStyleService
): void {
    const vm = angular.extend(this, {
        project,
        activeFilters: filterService.get(),
        filteredLicenses: licenseService.getFilteredLicenses(),
        fullLicenses: getFullLicenses(),
        cssSample: '',
        closestExpirationDate: '',
        closestVistorLimit: '',
        families: {},
        styles: {},
        foundries: [],
        fontDisplays: ['Auto', 'Block', 'Swap', 'Fallback', 'Optional'],
        fontStyles: ['Normal', 'Italic'],
        fontWeights: [
            'Normal',
            'Bold',
            '100',
            '200',
            '300',
            '400',
            '500',
            '600',
            '700',
            '800',
            '900',
        ],
        licenseToAdd: null,
        styleQuery: '',

        newDomain: '',
        getActiveProject,
        addDomain,
        removeDomain,
        trimDomain,

        addLicense,
        removeLicense,
        saveProject,
        searchLicenses,
        selectLicense,
        showAddLicensePopover,
    });

    initalize();
    function initalize() {
        licenseService.setFilteredLicenses(vm.activeFilters, project.licenses);
        vm.addLicensePopover = $tnPopover.popoverXS(
            angular.element('.popover-projects-addLicense')
        );

        const familyIds = project.licenses
            .map((license) => {
                return license.style.family;
            })
            .filter((e, i, arr) => {
                // Make unique
                return arr.indexOf(e, i + 1) === -1;
            });

        const styleIds = project.licenses.map((l) => l.style.id);

        foundryService.getDjangoFoundries().then(() => {
            vm.foundries = foundryService.djangoFoundriesIdxByDjanoId;
        });

        const stylesPromise = styleService
            .list({ id: styleIds })
            .then(({ results: styles }) =>
                styles.forEach((style) => (vm.styles[style.id] = style))
            );
        const familiesPromise = familyService
            .list({ id: familyIds })
            .then(({ results: families }) => {
                families.forEach((family) => (vm.families[family.id] = family));
            });

        return $q.all([stylesPromise, familiesPromise]);
    }

    function getActiveProject() {
        return vm.project;
    }

    function addDomain() {
        // Allow adding of first domain
        if (
            vm.newDomain !== null &&
            vm.newDomain !== '' &&
            vm.newProjectForm.newDomain.$valid
        ) {
            vm.getActiveProject().domains.push(vm.newDomain);
            vm.newDomain = '';
            saveProject();
        } else if (vm.newDomain === null) {
            vm.newDomain = '';
        }
    }

    function removeDomain(index) {
        vm.getActiveProject().domains.splice(index, 1);
        localProjects.saveProject(vm.project);
    }

    function trimDomain() {
        const newDomain = vm.newProjectForm.newDomain;
        if (newDomain.$viewValue[newDomain.$viewValue.length - 1] === '/') {
            vm.newDomain = newDomain.$viewValue.slice(
                0,
                newDomain.$viewValue.length - 1
            );
        }
        if (newDomain.$valid) {
            [
                'http://www.',
                'https://www.',
                'http://',
                'https://',
                'www.',
            ].forEach((bannedString) => {
                if (vm.newDomain.indexOf(bannedString) === 0) {
                    vm.newDomain = vm.newDomain.substring(bannedString.length);
                }
            });
        }
    }

    function getFullLicenses() {
        return licenseService.getLicensesFromServer().then((licenses) => {
            licenses = angular
                .copy(licenses)
                .filter(
                    (license) =>
                        license.fontRights.web &&
                        license.fontRights.web.active &&
                        !license.fontRights.web.self_hosted
                );

            licenses.forEach((license) => {
                const duplicateLicenses = licenses.filter(
                    (li) => li.style.id === license.style.id
                );
                if (duplicateLicenses.length > 1) {
                    duplicateLicenses
                        .sort(function (a, b) {
                            return a.fontRights.web.qty - b.fontRights.web.qty;
                        })
                        .pop();
                    duplicateLicenses.forEach((match) =>
                        licenses.splice(licenses.indexOf(match), 1)
                    );
                }
            });

            return licenses;
        });
    }

    function addLicense(licenseToAdd) {
        // nothing selected
        if (!licenseToAdd) {
            return;
        }

        // Find or create a license for this style in the project
        let index;
        const match = vm.project.licenses.filter(
            (result) => result.style.id === licenseToAdd.style.id
        );
        if (match.length === 0) {
            vm.project.licenses.push({
                fontRights: {},
                style: licenseToAdd.style,
            });
            index = vm.project.licenses.length - 1;
        } else {
            index = vm.project.licenses.indexOf(match[0]);
        }

        const webRight = licenseToAdd.fontRights['web'];
        const style = licenseToAdd.style;

        /*eslint-disable camelcase*/
        // Set default meta data
        webRight.font_family = abbreviateStyleName(style.name);
        webRight.font_display = 'Swap';
        webRight.font_style =
            parseInt(style.posture) === 1 ? 'Italic' : 'Normal';
        webRight.font_weight = 'Normal';

        // Update the license
        vm.project.licenses[index].fontRights['web'] = webRight;
        vm.addLicensePopover.hide();
        _saveProjectAndUpdateFilters();
        vm.styleQuery = '';
        vm.licenseToAdd = null;
    }

    function removeLicense($event, license) {
        angular
            .element('#table_row__style' + license.style.id)
            .fadeOut(function () {
                vm.project.licenses.splice(
                    vm.project.licenses.indexOf(license),
                    1
                );
                _saveProjectAndUpdateFilters();
            });
    }

    function saveProject() {
        localProjects.saveProject(vm.project);
    }

    function _saveProjectAndUpdateFilters() {
        saveProject();
        licenseService.setFilteredLicenses(
            vm.activeFilters,
            vm.project.licenses
        );
    }

    function searchLicenses(name) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        self.name = name;

        return vm.fullLicenses.then(function (licenses) {
            let results = angular.copy(licenses);

            if (self.name) {
                results = results.filter(
                    (license) =>
                        license.style.name
                            .toLowerCase()
                            .indexOf(self.name.toLowerCase()) > -1
                );
            }

            vm.filteredLicenses.forEach((license) => {
                const match = results.filter(
                    (result) => result.style.id === license.style.id
                )[0];
                if (match) {
                    results.splice(results.indexOf(match), 1);
                }
            });

            // Alphabetize then limit to 6 (done here as the typeahead doesn't like async)
            return $filter('orderBy')(results, 'style.name');
        });
    }

    function selectLicense($item) {
        vm.licenseToAdd = $item;
        vm.licenseToAddType = {
            desktop: false,
            web: true,
            app: false,
            epub: false,
        };
    }

    function showAddLicensePopover($event) {
        if (vm.styleQuery === null || typeof vm.styleQuery !== 'object') {
            vm.licenseToAdd = null;
        }

        vm.addLicensePopover.show($event.currentTarget);

        angular
            .element(
                '.popover-projects-addLicense .typeahead_visiblehover input'
            )
            .focus();
    }

    $scope.$watch(
        'vm.filteredLicenses',
        function (newLicenses) {
            // Calculate the license closest to expiration
            const expiringLicenses = newLicenses.filter(
                (license) =>
                    license.fontRights.web.end && license.fontRights.web.active
            );

            if (expiringLicenses.length > 0) {
                expiringLicenses.sort(function (a, b) {
                    const aEnd = new Date(a.fontRights.web.end).getTime();
                    const bEnd = new Date(b.fontRights.web.end).getTime();
                    return aEnd - bEnd;
                });

                vm.closestExpirationDate = $filter('date')(
                    new Date(expiringLicenses[0].fontRights.web.end),
                    'longDate'
                );
            } else {
                vm.closestExpirationDate = 'All licenses are unlimited';
            }

            // Calculate the license closet to usage limit
            const limitedLicenses = newLicenses.filter(
                (license) => license.fontRights.web.qty > -1
            );

            if (limitedLicenses.length > 0) {
                limitedLicenses.sort(function (a, b) {
                    return (
                        a.fontRights.web.qty -
                        a.fontRights.web.visits -
                        (b.fontRights.web.qty - b.fontRights.web.visits)
                    );
                });

                vm.closestVistorLimit =
                    $filter('number')(
                        limitedLicenses[0].fontRights.web.visits,
                        0
                    ) +
                    ' / ' +
                    $filter('number')(limitedLicenses[0].fontRights.web.qty, 0);
            } else {
                vm.closestVistorLimit = 'All licenses are unlimited';
            }
            updateCssSample();
        },
        true
    );

    $scope.$watch('vm.foundries', function () {
        updateCssSample();
    });

    function updateCssSample() {
        if (
            vm.filteredLicenses.length === 0 ||
            Object.keys(vm.foundries).length === 0
        ) {
            return;
        }

        const selectedLicenses = vm.filteredLicenses.filter(
            (license) => !license.fontRights.web.self_hosted
        );

        // use a set to deduplicate links.
        const eulas = new Set<IFoundryModel>();
        selectedLicenses.forEach((license) => {
            license.style.foundry.forEach((id) => {
                const foundry = vm.foundries[id];
                const href = $state.href(
                    'home.eula.foundry',
                    { eula_slug: foundry.eula },
                    { absolute: true }
                );
                foundry && eulas.add(href);
            });
        });
        const eulaLinks = Array.from(eulas).map((href) => `\t${href}\n`);

        vm.cssSample =
            '/***************************************************************\n' +
            'These styles are subject to the license agreement(s) provided when you purchased the license(s).\n\n' +
            eulaLinks +
            '\n' +
            '***************************************************************/\n\n';

        selectedLicenses.forEach((license) => {
            vm.cssSample +=
                '.' +
                license.style.name.toLocaleLowerCase().replace(/ |'/g, '') +
                ' {\n';
            vm.cssSample +=
                '    font-family: "' +
                license.fontRights.web.font_family +
                '";\n';
            vm.cssSample +=
                '    font-display: ' +
                license.fontRights.web.font_display.toLowerCase() +
                ';\n';
            vm.cssSample +=
                '    font-style: ' +
                license.fontRights.web.font_style.toLowerCase() +
                ';\n';
            vm.cssSample +=
                '    font-weight: ' +
                license.fontRights.web.font_weight.toLowerCase() +
                ';\n';
            vm.cssSample += '}\n\n';
        });
    }
}
